import * as React from 'react';
export const IcWifiLocked2 = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      opacity={0.2}
      d='M12 13a6 6 0 00-3.59 1.19 1 1 0 101.2 1.6A4 4 0 0112 15v-2zm0-8a14 14 0 00-9.34 3.59A1.002 1.002 0 104 10.08 11.94 11.94 0 0112 7c.64.003 1.278.057 1.91.16a5.05 5.05 0 011.89-1.63A13.78 13.78 0 0012 5zm.14 6a4.068 4.068 0 01.91-1.7v-.24a9.78 9.78 0 00-7.54 2.34 1 1 0 001.3 1.52A8 8 0 0112 11h.14zm0 6H12a1.5 1.5 0 101.4 2 4 4 0 01-1.25-2h-.01z'
      fill='currentColor'
    />
    <path
      d='M11.99 13a6 6 0 00-3.59 1.19 1 1 0 101.2 1.6 4 4 0 012.39-.79v-2zm.15 4h-.15a1.5 1.5 0 101.4 2 4 4 0 01-1.25-2zm8.85-6.72V10a3 3 0 00-6 0v.28a2 2 0 00-1 1.72v4a2 2 0 002 2h4a2 2 0 002-2v-4a2 2 0 00-1-1.72zm-3 4.72a1 1 0 110-2 1 1 0 010 2zm-1-5a1 1 0 012 0h-2z'
      fill='currentColor'
    />
  </svg>
);
